import {
  Box,
  Flex,
  GreyGrey80,
  Primary13Regular
} from '@sequencehq/core-components'
import { CurrentPayment } from 'Invoices/types'
import { getLogo } from 'lib/integrations/logos'

import {
  PAYMENT_ORIGIN_LABELS,
  PAYMENT_ORIGIN_LOGOS,
  PAYMENT_ORIGIN_LOGO_SIZE,
  UNKNOWN_PAYMENT_ORIGIN_LABEL
} from './payments.constants'
import { toCurrentPaymentOrigin } from './payments.utils'

// Typed off the payment rather than importing `PaymentOrigin`, whose name
// this component takes.
export const PaymentOrigin = ({
  origin,
  color = GreyGrey80,
  'data-testid': dataTestId
}: {
  origin: CurrentPayment['origin']
  color?: string
  'data-testid'?: string
}) => {
  const currentOrigin = toCurrentPaymentOrigin(origin)
  // Both undefined for a payment the backend served without an origin, and
  // at runtime for an origin added to the API but not to these maps.
  const label = currentOrigin ? PAYMENT_ORIGIN_LABELS[currentOrigin] : undefined
  const logoService = currentOrigin
    ? PAYMENT_ORIGIN_LOGOS[currentOrigin]
    : undefined

  return (
    <Flex alignItems="center" gap="8px" data-testid={dataTestId}>
      {logoService && getLogo(logoService, PAYMENT_ORIGIN_LOGO_SIZE)}
      <Box {...Primary13Regular} color={color}>
        {label ?? UNKNOWN_PAYMENT_ORIGIN_LABEL}
      </Box>
    </Flex>
  )
}
